
export const GET_RENEWAL_START = "GET_RENEWAL_START";
export const GET_RENEWAL_FAILURE = "GET_RENEWAL_FAILURE";
export const GET_RENEWAL_SUCCESS = "GET_RENEWAL_SUCCESS";
export const GET_RENEWAL_RESET = "GET_RENEWAL_RESET";

export const FIND_RENEWAL_START = "FIND_RENEWAL_START";
export const FIND_RENEWAL_FAILURE = "FIND_RENEWAL_FAILURE";
export const FIND_RENEWAL_SUCCESS = "FIND_RENEWAL_SUCCESS";
export const FIND_RENEWAL_RESET = "FIND_RENEWAL_RESET";

export const GETALL_RENEWAL_TRIGGER = "GETALL_RENEWAL_TRIGGER"
export const GETALL_RENEWAL_TRIGGER_SUCCESS = "GETALL_RENEWAL_TRIGGER_SUCCESS"
export const GETALL_RENEWAL_TRIGGER_FAILED = "GETALL_RENEWAL_TRIGGER_FAILED"

export const CREATE_RENEWAL_TRIGGER = "CREATE_RENEWAL_TRIGGER"
export const CREATE_RENEWAL_TRIGGER_SUCCESS = "CREATE_RENEWAL_TRIGGER_SUCCESS"
export const CREATE_RENEWAL_TRIGGER_FAILED = "CREATE_RENEWAL_TRIGGER_FAILED"


export const UPDATE_RENEWAL_TRIGGER = "UPDATE_RENEWAL_TRIGGER"
export const UPDATE_RENEWAL_TRIGGER_SUCCESS = "UPDATE_RENEWAL_TRIGGER_SUCCESS"
export const UPDATE_RENEWAL_TRIGGER_FAILED = "UPDATE_RENEWAL_TRIGGER_FAILED"

export const WHATSAPP_RENEWAL_MESSAGE = "WHATSAPP_RENEWAL_MESSAGE"
export const WHATSAPP_RENEWAL_MESSAGE_SUCCESS = "WHATSAPP_RENEWAL_MESSAGE_SUCCESS"
export const WHATSAPP_RENEWAL_MESSAGE_FAILED = "WHATSAPP_RENEWAL_MESSAGE_FAILED"
export const WHATSAPP_RENEWAL_MESSAGE_RESET = "WHATSAPP_RENEWAL_MESSAGE_RESET";